import * as tslib_1 from "tslib";
import { Data } from '../../data';
var FormField = /** @class */ (function (_super) {
    tslib_1.__extends(FormField, _super);
    function FormField(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'title';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    FormField.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "title": this.title, "type": "FormField" });
    };
    FormField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return FormField;
}(Data));
export { FormField };
//# sourceMappingURL=form_field.js.map